import { Box, Grid } from '@mui/material';
import './titles.scss';
import Icon from '../icon/icon';

export const Titles = ({props}:any) => {
    return (
        <Box>
            <Grid container justifyContent={'center'}>
                <Grid item xs={12}>
                    <div className='container-body-attendance'>
                        <div className="icon-mobile-title" style={{display: 'none'}}>
                            <Icon name={props?.icon} width='50' height='45' color='#f82e4b'></Icon>
                        </div>
                        <h1 className="title">{props.title}</h1>
                        <h2 className="description mb-2">{props.description}</h2>     
                    </div>
                </Grid>
            </Grid>
        </Box>
    )
}